/**
 * A failed login. `code` is the machine readable reason sent by the auth
 * service, when it sends one: `totp_required`, `totp_invalid` or
 * `totp_locked` for a user with two-factor authentication.
 */
export class LoginError extends Error {
  readonly code?: string;
  /** With `login_locked`: minutes to wait before trying again. */
  readonly retryAfterMinutes?: number;

  constructor (message: string, code?: string, retryAfterMinutes?: number) {
    super(message);
    this.name = 'LoginError';
    this.code = code;
    this.retryAfterMinutes = retryAfterMinutes;
  }
}
